import { Navigate,useLocation } from 'react-router-dom';
import { useAuth } from '../../useAuth'

export const ProtectedRoute = ({ children,role  }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();
  const userRole = localStorage.getItem("userRole");
  
  if (isLoading) {
    return <div>Loading...</div>; // Or a proper loading spinner component
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }
  // Role mismatch redirects
  if (role && userRole !== role) {
    if (userRole === "university_admin") {
      return <Navigate to="/admin" replace />;
    }
    if (userRole === "student") {
      return <Navigate to="/landingPage/profile" replace />;
    }
  }

  
  return children;
};